// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__TvR8j","label":"CategoryService_label__2t-mm","location":"CategoryService_location__mveZG"};